module.exports = __webpack_public_path__ + "img/ryzs9.e585ec23.jpg";